import _toConsumableArray from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { getDefaultProvider } from '@ethersproject/providers';
import { balanceAction, defaultChains, defaultL2Chains, ConnectorAlreadyConnectedError, allChains, SwitchChainError, ConnectorNotFoundError, UserRejectedRequestError, erc20ABI, InjectedConnector } from 'wagmi-core';
export { AddChainError, ChainNotConfiguredError, Connector, ConnectorAlreadyConnectedError, ConnectorNotFoundError, InjectedConnector, SwitchChainError, UserRejectedRequestError, allChains, chain, defaultChains, defaultL2Chains, developmentChains, erc1155ABI, erc20ABI, erc721ABI, normalizeChainId } from 'wagmi-core';
import { utils, Contract, ethers } from 'ethers';

var useProvider = function useProvider() {
  var _useContext = useContext(),
      state = _useContext.state;

  return state.provider;
};

var useWebSocketProvider = function useWebSocketProvider() {
  var _useContext2 = useContext(),
      state = _useContext2.state;

  return state.webSocketProvider;
};

var useCacheBuster = function useCacheBuster() {
  var context = useContext();
  return context.state.cacheBuster;
};

var useCancel = function useCancel() {
  var cancelCallback = React.useRef(null);
  React.useEffect(function () {
    return function () {
      var _cancelCallback$curre;

      return (_cancelCallback$curre = cancelCallback.current) === null || _cancelCallback$curre === void 0 ? void 0 : _cancelCallback$curre.call(cancelCallback);
    };
  }, []);
  var cancel = React.useCallback(function (callback) {
    var _cancelCallback$curre2;

    (_cancelCallback$curre2 = cancelCallback.current) === null || _cancelCallback$curre2 === void 0 ? void 0 : _cancelCallback$curre2.call(cancelCallback);
    if (callback) cancelCallback.current = callback;
  }, []);
  return cancel;
};

var useLocalStorage = function useLocalStorage(key) {
  var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _React$useState = React.useState(function () {
    if (typeof localStorage === 'undefined') return defaultState;
    var value = localStorage.getItem(key);

    try {
      return value ? JSON.parse(value) : defaultState;
    } catch (error) {
      console.warn(error);
      return defaultState;
    }
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var setLocalStorage = React.useCallback(function (newValue) {
    if (newValue === value) return;
    setValue(newValue);
    if (newValue === null) localStorage.removeItem(key);else localStorage.setItem(key, JSON.stringify(newValue));

    if (newValue === null) {
      localStorage.removeItem(key);
    } else {
      try {
        localStorage.setItem(key, JSON.stringify(newValue));
      } catch (error) {
        console.error(error);
      }
    }
  }, [value, setValue, key]);
  return [value, setLocalStorage];
};

var initialState$g = {
  loading: false
};

var useEnsAvatar = function useEnsAvatar() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      addressOrName = _ref3.addressOrName,
      skip = _ref3.skip;

  var cacheBuster = useCacheBuster();
  var provider = useProvider();

  var _React$useState3 = React.useState(initialState$g),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      state = _React$useState4[0],
      setState = _React$useState4[1];

  var cancelQuery = useCancel();
  var getEnsAvatar = React.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
      var didCancel, config_, avatar, error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                addressOrName: addressOrName
              };

              if (config_.addressOrName) {
                _context.next = 6;
                break;
              }

              throw new Error('addressOrName is required');

            case 6:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true
                });
              });
              _context.next = 9;
              return provider.getAvatar(config_.addressOrName);

            case 9:
              avatar = _context.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    avatar: avatar,
                    loading: false
                  });
                });
              }

              return _context.abrupt("return", avatar);

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](2);
              error = _context.t0;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context.abrupt("return", error);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 14]]);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [addressOrName, cancelQuery, provider]); // Fetch avatar when deps or chain changes

  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip || !addressOrName) return;
    getEnsAvatar({
      addressOrName: addressOrName
    });
    return cancelQuery;
  }, [addressOrName, cacheBuster, cancelQuery, skip]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [{
    data: state.avatar,
    loading: state.loading,
    error: state.error
  }, getEnsAvatar];
};

var initialState$f = {
  loading: false
};

var useEnsLookup = function useEnsLookup() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref5.address,
      skip = _ref5.skip;

  var cacheBuster = useCacheBuster();
  var provider = useProvider();

  var _React$useState5 = React.useState(initialState$f),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      state = _React$useState6[0],
      setState = _React$useState6[1];

  var cancelQuery = useCancel();
  var lookupAddress = React.useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(config) {
      var didCancel, config_, ens, error;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context2.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                address: address
              };

              if (config_.address) {
                _context2.next = 6;
                break;
              }

              throw new Error('address is required');

            case 6:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true
                });
              });
              _context2.next = 9;
              return provider.lookupAddress(config_.address);

            case 9:
              ens = _context2.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    ens: ens,
                    loading: false
                  });
                });
              }

              return _context2.abrupt("return", {
                data: ens,
                error: undefined
              });

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](2);
              error = _context2.t0;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context2.abrupt("return", {
                data: undefined,
                error: error
              });

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 14]]);
    }));

    return function (_x2) {
      return _ref6.apply(this, arguments);
    };
  }(), [address, cancelQuery, provider]); // Resolve name when deps or chain changes

  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip || !address) return;
    lookupAddress({
      address: address
    });
    return cancelQuery;
  }, [address, cacheBuster, cancelQuery, skip]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [{
    data: state.ens,
    loading: state.loading,
    error: state.error
  }, lookupAddress];
};

var initialState$e = {
  loading: false
};

var useEnsResolveName = function useEnsResolveName() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref7.name,
      skip = _ref7.skip;

  var cacheBuster = useCacheBuster();
  var provider = useProvider();

  var _React$useState7 = React.useState(initialState$e),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      state = _React$useState8[0],
      setState = _React$useState8[1];

  var cancelQuery = useCancel();
  var resolveName = React.useCallback( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(config) {
      var didCancel, config_, address, error;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context3.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                name: name
              };

              if (config_.name) {
                _context3.next = 6;
                break;
              }

              throw new Error('name is required');

            case 6:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true
                });
              });
              _context3.next = 9;
              return provider.resolveName(config_.name);

            case 9:
              address = _context3.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    address: address,
                    loading: false
                  });
                });
              }

              return _context3.abrupt("return", {
                data: address,
                error: undefined
              });

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](2);
              error = _context3.t0;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context3.abrupt("return", {
                data: undefined,
                error: error
              });

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 14]]);
    }));

    return function (_x3) {
      return _ref8.apply(this, arguments);
    };
  }(), [name, cancelQuery, provider]); // Resolve name when deps or chain changes

  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip || !name) return;
    resolveName({
      name: name
    });
    return cancelQuery;
  }, [name, cacheBuster, cancelQuery, skip]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [{
    data: state.address,
    loading: state.loading,
    error: state.error
  }, resolveName];
};

var initialState$d = {
  loading: false
};

var useEnsResolver = function useEnsResolver() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref9.name,
      skip = _ref9.skip;

  var cacheBuster = useCacheBuster();
  var provider = useProvider();

  var _React$useState9 = React.useState(initialState$d),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      state = _React$useState10[0],
      setState = _React$useState10[1];

  var cancelQuery = useCancel();
  var getEnsResolver = React.useCallback( /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(config) {
      var didCancel, config_, resolver, error;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context4.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                name: name
              };

              if (config_.name) {
                _context4.next = 6;
                break;
              }

              throw new Error('name is required');

            case 6:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true
                });
              });
              _context4.next = 9;
              return provider.getResolver(config_.name);

            case 9:
              resolver = _context4.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    loading: false,
                    resolver: resolver
                  });
                });
              }

              return _context4.abrupt("return", {
                data: resolver,
                error: undefined
              });

            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](2);
              error = _context4.t0;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context4.abrupt("return", {
                data: undefined,
                error: error
              });

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 14]]);
    }));

    return function (_x4) {
      return _ref10.apply(this, arguments);
    };
  }(), [cancelQuery, name, provider]); // Fetch avatar when deps or chain changes

  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip || !name) return;
    getEnsResolver({
      name: name
    });
    return cancelQuery;
  }, [cacheBuster, cancelQuery, name, skip]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [{
    data: state.resolver,
    loading: state.loading,
    error: state.error
  }, getEnsResolver];
};

var useAccount = function useAccount() {
  var _globalState$data;

  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      fetchEns = _ref11.fetchEns;

  var _useContext3 = useContext(),
      globalState = _useContext3.state,
      setState = _useContext3.setState;

  var address = (_globalState$data = globalState.data) === null || _globalState$data === void 0 ? void 0 : _globalState$data.account;

  var _useEnsLookup = useEnsLookup({
    address: address,
    skip: !fetchEns
  }),
      _useEnsLookup2 = _slicedToArray(_useEnsLookup, 1),
      _useEnsLookup2$ = _useEnsLookup2[0],
      ens = _useEnsLookup2$.data,
      ensError = _useEnsLookup2$.error,
      ensLoading = _useEnsLookup2$.loading;

  var _useEnsAvatar = useEnsAvatar({
    addressOrName: ens,
    skip: !fetchEns || !ens
  }),
      _useEnsAvatar2 = _slicedToArray(_useEnsAvatar, 1),
      _useEnsAvatar2$ = _useEnsAvatar2[0],
      avatar = _useEnsAvatar2$.data,
      avatarError = _useEnsAvatar2$.error,
      avatarLoading = _useEnsAvatar2$.loading;

  var disconnect = React.useCallback(function () {
    setState(function (x) {
      var _x$connector;

      (_x$connector = x.connector) === null || _x$connector === void 0 ? void 0 : _x$connector.disconnect();
      return {
        cacheBuster: x.cacheBuster + 1
      };
    });
  }, [setState]);
  var error = ensError || avatarError;
  var loading = ensLoading || avatarLoading;
  return [{
    data: address ? {
      address: address,
      connector: globalState.connector,
      ens: ens ? {
        avatar: avatar,
        name: ens
      } : undefined
    } : undefined,
    error: error,
    loading: loading
  }, disconnect];
};

var initialState$c = {
  loading: false
};

var useBlockNumber = function useBlockNumber() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      skip = _ref12.skip,
      watch = _ref12.watch;

  var cacheBuster = useCacheBuster();
  var provider = useProvider();
  var webSocketProvider = useWebSocketProvider();

  var _React$useState11 = React.useState(initialState$c),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      state = _React$useState12[0],
      setState = _React$useState12[1];

  var cancelQuery = useCancel();
  var getBlockNumber = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var didCancel, blockNumber, error;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            didCancel = false;
            cancelQuery(function () {
              didCancel = true;
            });
            _context5.prev = 2;
            setState(function (x) {
              return _objectSpread(_objectSpread({}, x), {}, {
                error: undefined,
                loading: true
              });
            });
            _context5.next = 6;
            return provider.getBlockNumber();

          case 6:
            blockNumber = _context5.sent;

            if (!didCancel) {
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  blockNumber: blockNumber,
                  loading: false
                });
              });
            }

            return _context5.abrupt("return", {
              data: blockNumber,
              error: undefined
            });

          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](2);
            error = _context5.t0;

            if (!didCancel) {
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: error,
                  loading: false
                });
              });
            }

            return _context5.abrupt("return", {
              data: undefined,
              error: error
            });

          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 11]]);
  })), [cancelQuery, provider]);
  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip) return;
    getBlockNumber();
    return cancelQuery;
  }, [cacheBuster, cancelQuery, skip]);
  /* eslint-enable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (!watch) return;
    var didCancel = false;

    var listener = function listener(blockNumber) {
      // Just to be safe in case the provider implementation
      // calls the event callback after .off() has been called
      if (!didCancel) {
        setState(function (x) {
          return _objectSpread(_objectSpread({}, x), {}, {
            blockNumber: blockNumber
          });
        });
      }
    };

    var provider_ = webSocketProvider !== null && webSocketProvider !== void 0 ? webSocketProvider : provider;
    provider_.on('block', listener);
    return function () {
      didCancel = true;
      provider_.off('block', listener);
    };
  }, [provider, watch, webSocketProvider]);
  return [{
    data: state.blockNumber,
    error: state.error,
    loading: state.loading
  }, getBlockNumber];
};

var initialState$b = {
  loading: false
};

var useFeeData = function useFeeData() {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref14$formatUnits = _ref14.formatUnits,
      formatUnits = _ref14$formatUnits === void 0 ? 'wei' : _ref14$formatUnits,
      skip = _ref14.skip,
      watch = _ref14.watch;

  var provider = useProvider();

  var _useBlockNumber = useBlockNumber({
    skip: true,
    watch: watch
  }),
      _useBlockNumber2 = _slicedToArray(_useBlockNumber, 1),
      blockNumber = _useBlockNumber2[0].data;

  var cacheBuster = useCacheBuster();

  var _React$useState13 = React.useState(initialState$b),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      state = _React$useState14[0],
      setState = _React$useState14[1];

  var cancelQuery = useCancel();
  var getFeeData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var didCancel, feeData, error;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            didCancel = false;
            cancelQuery(function () {
              didCancel = true;
            });
            _context6.prev = 2;
            setState(function (x) {
              return _objectSpread(_objectSpread({}, x), {}, {
                error: undefined,
                loading: true
              });
            });
            _context6.next = 6;
            return provider.getFeeData();

          case 6:
            feeData = _context6.sent;

            if (!didCancel) {
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  feeData: feeData,
                  loading: false
                });
              });
            }

            return _context6.abrupt("return", {
              data: feeData,
              error: undefined
            });

          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](2);
            error = _context6.t0;

            if (!didCancel) {
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: error,
                  loading: false
                });
              });
            }

            return _context6.abrupt("return", {
              data: undefined,
              error: error
            });

          case 16:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[2, 11]]);
  })), [cancelQuery, provider]); // Fetch feeData on mount or when chain changes

  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip) return;
    getFeeData();
    return cancelQuery;
  }, [cacheBuster, cancelQuery, skip]);
  /* eslint-enable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (!watch || !blockNumber) return;
    getFeeData();
    return cancelQuery;
  }, [blockNumber, cancelQuery, getFeeData, watch]);
  var formatted = state.feeData ? {
    gasPrice: utils.formatUnits(state.feeData.gasPrice, formatUnits),
    maxFeePerGas: utils.formatUnits(state.feeData.maxFeePerGas, formatUnits),
    maxPriorityFeePerGas: utils.formatUnits(state.feeData.maxPriorityFeePerGas, formatUnits)
  } : undefined;
  return [{
    data: state.feeData ? _objectSpread(_objectSpread({}, state.feeData), {}, {
      formatted: formatted
    }) : undefined,
    loading: state.loading,
    error: state.error
  }, getFeeData];
};

var initialState$a = {
  loading: false
};

var useBalance = function useBalance() {
  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      addressOrName = _ref16.addressOrName,
      _ref16$formatUnits = _ref16.formatUnits,
      formatUnits = _ref16$formatUnits === void 0 ? 'ether' : _ref16$formatUnits,
      skip = _ref16.skip,
      token = _ref16.token,
      watch = _ref16.watch;

  var _useContext4 = useContext(),
      connector = _useContext4.state.connector;

  var cacheBuster = useCacheBuster();
  var provider = useProvider();

  var _useBlockNumber3 = useBlockNumber({
    skip: true,
    watch: watch
  }),
      _useBlockNumber4 = _slicedToArray(_useBlockNumber3, 1),
      blockNumber = _useBlockNumber4[0].data;

  var _React$useState15 = React.useState(initialState$a),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      state = _React$useState16[0],
      setState = _React$useState16[1];

  var cancelQuery = useCancel();
  var getBalance = React.useCallback( /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(config) {
      var didCancel, _connector$chains, config_, balance, error;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context7.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                addressOrName: addressOrName,
                formatUnits: formatUnits,
                token: token
              };

              if (config_.addressOrName) {
                _context7.next = 6;
                break;
              }

              throw new Error('address is required');

            case 6:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true
                });
              });
              _context7.next = 9;
              return balanceAction({
                chains: [].concat(_toConsumableArray((_connector$chains = connector === null || connector === void 0 ? void 0 : connector.chains) !== null && _connector$chains !== void 0 ? _connector$chains : []), _toConsumableArray(defaultChains), _toConsumableArray(defaultL2Chains)),
                config: config_,
                provider: provider
              });

            case 9:
              balance = _context7.sent;
              if (!didCancel) setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  balance: balance,
                  loading: false
                });
              });
              return _context7.abrupt("return", {
                data: balance,
                error: undefined
              });

            case 14:
              _context7.prev = 14;
              _context7.t0 = _context7["catch"](2);
              error = _context7.t0;
              if (!didCancel) setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: error,
                  loading: false
                });
              });
              return _context7.abrupt("return", {
                data: undefined,
                error: error
              });

            case 19:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[2, 14]]);
    }));

    return function (_x5) {
      return _ref17.apply(this, arguments);
    };
  }(), [addressOrName, cancelQuery, connector, formatUnits, provider, token]); // Fetch balance when deps or chain changes

  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip || !addressOrName) return;
    getBalance({
      addressOrName: addressOrName,
      formatUnits: formatUnits,
      token: token
    });
    return cancelQuery;
  }, [addressOrName, cacheBuster, cancelQuery, skip, token]);
  /* eslint-enable react-hooks/exhaustive-deps */

  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (!watch) return;
    if (!blockNumber) return;
    if (!addressOrName) return;
    getBalance({
      addressOrName: addressOrName,
      formatUnits: formatUnits,
      token: token
    });
  }, [blockNumber]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [{
    data: state.balance,
    error: state.error,
    loading: state.loading
  }, getBalance];
};

var initialState$9 = {
  loading: false
};

var useConnect = function useConnect() {
  var _globalState$data;

  var _useContext5 = useContext(),
      globalState = _useContext5.state,
      setGlobalState = _useContext5.setState,
      setLastUsedConnector = _useContext5.setLastUsedConnector;

  var _React$useState17 = React.useState(initialState$9),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      state = _React$useState18[0],
      setState = _React$useState18[1];

  var cancelQuery = useCancel();
  var connect = React.useCallback( /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(connector) {
      var didCancel, activeConnector, data, error;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context8.prev = 2;
              activeConnector = globalState === null || globalState === void 0 ? void 0 : globalState.connector;

              if (!(connector === activeConnector)) {
                _context8.next = 6;
                break;
              }

              throw new ConnectorAlreadyConnectedError();

            case 6:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  loading: true,
                  connector: connector,
                  error: undefined
                });
              });
              _context8.next = 9;
              return connector.connect();

            case 9:
              data = _context8.sent;

              if (!didCancel) {
                // Update connector globally only after successful connection
                setGlobalState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    connector: connector,
                    data: data
                  });
                });
                setLastUsedConnector(connector.name);
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    loading: false
                  });
                });
              }

              return _context8.abrupt("return", {
                data: data,
                error: undefined
              });

            case 14:
              _context8.prev = 14;
              _context8.t0 = _context8["catch"](2);
              error = _context8.t0;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    connector: undefined,
                    error: error,
                    loading: false
                  });
                });
              }

              return _context8.abrupt("return", {
                data: undefined,
                error: error
              });

            case 19:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[2, 14]]);
    }));

    return function (_x6) {
      return _ref18.apply(this, arguments);
    };
  }(), [cancelQuery, globalState.connector, setGlobalState, setLastUsedConnector]); // Keep connector in sync with global connector

  React.useEffect(function () {
    setState(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        connector: globalState.connector,
        error: undefined
      });
    });
    return cancelQuery;
  }, [cancelQuery, globalState.connector]);
  return [{
    data: {
      connected: !!((_globalState$data = globalState.data) !== null && _globalState$data !== void 0 && _globalState$data.account),
      connector: state.connector,
      connectors: globalState.connectors
    },
    error: state.error,
    loading: state.loading || globalState.connecting
  }, connect];
};

var initialState$8 = {
  loading: false
};

var useNetwork = function useNetwork() {
  var _data$chain, _data$chain2, _connector$chains;

  var _useContext6 = useContext(),
      _useContext6$state = _useContext6.state,
      connector = _useContext6$state.connector,
      data = _useContext6$state.data;

  var _React$useState19 = React.useState(initialState$8),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      state = _React$useState20[0],
      setState = _React$useState20[1];

  var chainId = data === null || data === void 0 ? void 0 : (_data$chain = data.chain) === null || _data$chain === void 0 ? void 0 : _data$chain.id;
  var unsupported = data === null || data === void 0 ? void 0 : (_data$chain2 = data.chain) === null || _data$chain2 === void 0 ? void 0 : _data$chain2.unsupported;
  var activeChains = (_connector$chains = connector === null || connector === void 0 ? void 0 : connector.chains) !== null && _connector$chains !== void 0 ? _connector$chains : [];
  var activeChain = [].concat(_toConsumableArray(activeChains), _toConsumableArray(allChains)).find(function (x) {
    return x.id === chainId;
  });
  var cancelQuery = useCancel();
  var switchNetwork = React.useCallback( /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(chainId) {
      var didCancel, chain, error;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });

              if (connector !== null && connector !== void 0 && connector.switchChain) {
                _context9.next = 4;
                break;
              }

              return _context9.abrupt("return", {
                data: undefined,
                error: new SwitchChainError()
              });

            case 4:
              _context9.prev = 4;
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true
                });
              });
              _context9.next = 8;
              return connector.switchChain(chainId);

            case 8:
              chain = _context9.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    loading: false
                  });
                });
              }

              return _context9.abrupt("return", {
                data: chain,
                error: undefined
              });

            case 13:
              _context9.prev = 13;
              _context9.t0 = _context9["catch"](4);
              error = _context9.t0;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context9.abrupt("return", {
                data: undefined,
                error: error
              });

            case 18:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[4, 13]]);
    }));

    return function (_x7) {
      return _ref19.apply(this, arguments);
    };
  }(), [cancelQuery, connector]);
  return [{
    data: {
      chain: chainId ? _objectSpread(_objectSpread({}, activeChain), {}, {
        id: chainId,
        unsupported: unsupported
      }) : undefined,
      chains: activeChains
    },
    error: state.error,
    loading: state.loading
  }, connector !== null && connector !== void 0 && connector.switchChain ? switchNetwork : undefined];
};

var initialState$7 = {
  data: undefined,
  error: undefined,
  loading: false
};

var useSigner = function useSigner() {
  var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      skip = _ref20.skip;

  var cacheBuster = useCacheBuster();

  var _useContext7 = useContext(),
      connector = _useContext7.state.connector;

  var _React$useState21 = React.useState(initialState$7),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      state = _React$useState22[0],
      setState = _React$useState22[1];

  var cancelQuery = useCancel();
  var getSigner = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var didCancel, signer, error;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            didCancel = false;
            cancelQuery(function () {
              didCancel = true;
            });
            _context10.prev = 2;
            setState(function (x) {
              return _objectSpread(_objectSpread({}, x), {}, {
                error: undefined,
                loading: true
              });
            });
            _context10.next = 6;
            return connector === null || connector === void 0 ? void 0 : connector.getSigner();

          case 6:
            signer = _context10.sent;

            if (!didCancel) {
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  data: signer,
                  loading: false
                });
              });
            }

            return _context10.abrupt("return", signer);

          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](2);
            error = _context10.t0;

            if (!didCancel) {
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  data: undefined,
                  error: error,
                  loading: false
                });
              });
            }

          case 15:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[2, 11]]);
  })), [cancelQuery, connector]);
  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip) return;
    getSigner();
    return cancelQuery;
  }, [cacheBuster, connector, cancelQuery, skip]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [state, getSigner];
};

var initialState$6 = {
  loading: false
};

var useSignMessage = function useSignMessage() {
  var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref22.message;

  var _useContext8 = useContext(),
      connector = _useContext8.state.connector;

  var _React$useState23 = React.useState(initialState$6),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      state = _React$useState24[0],
      setState = _React$useState24[1];

  var cancelQuery = useCancel();
  var signMessage = React.useCallback( /*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(config) {
      var didCancel, config_, signer, signature, error;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context11.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                message: message
              };

              if (config_.message) {
                _context11.next = 6;
                break;
              }

              throw new Error('message is required');

            case 6:
              if (connector) {
                _context11.next = 8;
                break;
              }

              throw new ConnectorNotFoundError();

            case 8:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true
                });
              });
              _context11.next = 11;
              return connector.getSigner();

            case 11:
              signer = _context11.sent;
              _context11.next = 14;
              return signer.signMessage(config_.message);

            case 14:
              signature = _context11.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    signature: signature,
                    loading: false
                  });
                });
              }

              return _context11.abrupt("return", {
                data: signature,
                error: undefined
              });

            case 19:
              _context11.prev = 19;
              _context11.t0 = _context11["catch"](2);
              error = _context11.t0;
              if (_context11.t0.code === 4001) error = new UserRejectedRequestError();

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context11.abrupt("return", {
                data: undefined,
                error: error
              });

            case 25:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[2, 19]]);
    }));

    return function (_x8) {
      return _ref23.apply(this, arguments);
    };
  }(), [cancelQuery, connector, message]);
  return [{
    data: state.signature,
    error: state.error,
    loading: state.loading
  }, signMessage];
};

var initialState$5 = {
  loading: false
};

var useSignTypedData = function useSignTypedData() {
  var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      domain = _ref24.domain,
      types = _ref24.types,
      value = _ref24.value;

  var _useContext9 = useContext(),
      connector = _useContext9.state.connector;

  var _React$useState25 = React.useState(initialState$5),
      _React$useState26 = _slicedToArray(_React$useState25, 2),
      state = _React$useState26[0],
      setState = _React$useState26[1];

  var cancelQuery = useCancel();
  var signTypedData = React.useCallback( /*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(config) {
      var didCancel, config_, signer, signature, error;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context12.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                domain: domain,
                types: types,
                value: value
              };

              if (config_.domain) {
                _context12.next = 6;
                break;
              }

              throw new Error('domain is required');

            case 6:
              if (config_.types) {
                _context12.next = 8;
                break;
              }

              throw new Error('type is required');

            case 8:
              if (config_.value) {
                _context12.next = 10;
                break;
              }

              throw new Error('value is required');

            case 10:
              if (connector) {
                _context12.next = 12;
                break;
              }

              throw new ConnectorNotFoundError();

            case 12:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true
                });
              });
              _context12.next = 15;
              return connector.getSigner();

            case 15:
              signer = _context12.sent;
              _context12.next = 18;
              return signer._signTypedData(config_.domain, config_.types, config_.value);

            case 18:
              signature = _context12.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    signature: signature,
                    loading: false
                  });
                });
              }

              return _context12.abrupt("return", {
                data: signature,
                error: undefined
              });

            case 23:
              _context12.prev = 23;
              _context12.t0 = _context12["catch"](2);
              error = _context12.t0;
              if (_context12.t0.code === 4001) error = new UserRejectedRequestError();

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context12.abrupt("return", {
                data: undefined,
                error: error
              });

            case 29:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[2, 23]]);
    }));

    return function (_x9) {
      return _ref25.apply(this, arguments);
    };
  }(), [cancelQuery, connector, domain, types, value]);
  return [{
    data: state.signature,
    error: state.error,
    loading: state.loading
  }, signTypedData];
};

var getContract = function getContract(_ref) {
  var addressOrName = _ref.addressOrName,
      contractInterface = _ref.contractInterface,
      signerOrProvider = _ref.signerOrProvider;
  return new Contract(addressOrName, contractInterface, signerOrProvider);
};

var useContract = function useContract(_ref2) {
  var addressOrName = _ref2.addressOrName,
      contractInterface = _ref2.contractInterface,
      signerOrProvider = _ref2.signerOrProvider;
  return React.useMemo(function () {
    return getContract({
      addressOrName: addressOrName,
      contractInterface: contractInterface,
      signerOrProvider: signerOrProvider
    });
  }, [addressOrName, contractInterface, signerOrProvider]);
};

var useContractEvent = function useContractEvent(contractConfig, eventName, listener) {
  var _ref26 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      once = _ref26.once;

  var provider = useProvider();
  var webSocketProvider = useWebSocketProvider();
  var contract = useContract(_objectSpread({
    signerOrProvider: webSocketProvider !== null && webSocketProvider !== void 0 ? webSocketProvider : provider
  }, contractConfig));
  var listenerRef = React.useRef(listener);
  listenerRef.current = listener;
  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    var handler = function handler() {
      for (var _len = arguments.length, event = new Array(_len), _key = 0; _key < _len; _key++) {
        event[_key] = arguments[_key];
      }

      return listenerRef.current(event);
    };

    var contract_ = contract;
    if (once) contract_.once(eventName, handler);else contract_.on(eventName, handler);
    return function () {
      contract_.off(eventName, handler);
    };
  }, [contract, eventName]);
  /* eslint-enable react-hooks/exhaustive-deps */
};

var initialState$4 = {
  loading: false
};

var useContractRead = function useContractRead(contractConfig, functionName) {
  var _ref27 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      args = _ref27.args,
      overrides = _ref27.overrides,
      skip = _ref27.skip,
      watch = _ref27.watch;

  var cacheBuster = useCacheBuster();
  var provider = useProvider();
  var contract = useContract(_objectSpread({
    signerOrProvider: provider
  }, contractConfig));

  var _useBlockNumber5 = useBlockNumber({
    skip: true,
    watch: watch
  }),
      _useBlockNumber6 = _slicedToArray(_useBlockNumber5, 1),
      blockNumber = _useBlockNumber6[0].data;

  var _React$useState27 = React.useState(initialState$4),
      _React$useState28 = _slicedToArray(_React$useState27, 2),
      state = _React$useState28[0],
      setState = _React$useState28[1];

  var cancelQuery = useCancel();
  var read = React.useCallback( /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(config) {
      var didCancel, config_, params, response, error;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context13.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                args: args,
                overrides: overrides
              };
              params = [].concat(_toConsumableArray(Array.isArray(config_.args) ? config_.args : config_.args ? [config_.args] : []), _toConsumableArray(config_.overrides ? [config_.overrides] : []));
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true,
                  response: undefined
                });
              });
              _context13.next = 8;
              return contract[functionName].apply(contract, _toConsumableArray(params));

            case 8:
              response = _context13.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    loading: false,
                    response: response
                  });
                });
              }

              return _context13.abrupt("return", {
                data: response,
                error: undefined
              });

            case 13:
              _context13.prev = 13;
              _context13.t0 = _context13["catch"](2);
              error = _context13.t0;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context13.abrupt("return", {
                data: undefined,
                error: error
              });

            case 18:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[2, 13]]);
    }));

    return function (_x10) {
      return _ref28.apply(this, arguments);
    };
  }(), [args, cancelQuery, contract, functionName, overrides]);
  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip) return;
    read();
    return cancelQuery;
  }, [cacheBuster, cancelQuery, skip]);
  /* eslint-enable react-hooks/exhaustive-deps */

  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (!watch) return;
    if (!blockNumber) return;
    read();
    return cancelQuery;
  }, [blockNumber, cancelQuery, watch]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [{
    data: state.response,
    error: state.error,
    loading: state.loading
  }, read];
};

var initialState$3 = {
  loading: false
};

var useContractWrite = function useContractWrite(contractConfig, functionName) {
  var _ref29 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      args = _ref29.args,
      overrides = _ref29.overrides;

  var _useContext10 = useContext(),
      connector = _useContext10.state.connector;

  var contract = useContract(contractConfig);

  var _React$useState29 = React.useState(initialState$3),
      _React$useState30 = _slicedToArray(_React$useState29, 2),
      state = _React$useState30[0],
      setState = _React$useState30[1];

  var cancelQuery = useCancel();
  var write = React.useCallback( /*#__PURE__*/function () {
    var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(config) {
      var didCancel, config_, params, signer, contract_, response, error;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context14.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                args: args,
                overrides: overrides
              };

              if (connector) {
                _context14.next = 6;
                break;
              }

              throw new ConnectorNotFoundError();

            case 6:
              params = [].concat(_toConsumableArray(Array.isArray(config_.args) ? config_.args : config_.args ? [config_.args] : []), _toConsumableArray(config_.overrides ? [config_.overrides] : []));
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true,
                  response: undefined
                });
              });
              _context14.next = 10;
              return connector.getSigner();

            case 10:
              signer = _context14.sent;
              contract_ = contract.connect(signer);
              _context14.next = 14;
              return contract_[functionName].apply(contract_, _toConsumableArray(params));

            case 14:
              response = _context14.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    loading: false,
                    response: response
                  });
                });
              }

              return _context14.abrupt("return", {
                data: response,
                error: undefined
              });

            case 19:
              _context14.prev = 19;
              _context14.t0 = _context14["catch"](2);
              error = _context14.t0;
              if (_context14.t0.code === 4001) error = new UserRejectedRequestError();

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context14.abrupt("return", {
                data: undefined,
                error: error
              });

            case 25:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[2, 19]]);
    }));

    return function (_x11) {
      return _ref30.apply(this, arguments);
    };
  }(), [args, cancelQuery, connector, contract, functionName, overrides]);
  return [{
    data: state.response,
    error: state.error,
    loading: state.loading
  }, write];
};

var initialState$2 = {
  loading: false
};

var useToken = function useToken() {
  var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref31.address,
      _ref31$formatUnits = _ref31.formatUnits,
      formatUnits = _ref31$formatUnits === void 0 ? 'ether' : _ref31$formatUnits,
      skip = _ref31.skip;

  var _useContext11 = useContext(),
      connector = _useContext11.state.connector;

  var provider = useProvider();

  var _React$useState31 = React.useState(initialState$2),
      _React$useState32 = _slicedToArray(_React$useState31, 2),
      state = _React$useState32[0],
      setState = _React$useState32[1];

  var cancelQuery = useCancel();
  var getToken = React.useCallback( /*#__PURE__*/function () {
    var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(config) {
      var didCancel, _config_$formatUnits, config_, contract, formatUnits_, _yield$Promise$all, _yield$Promise$all2, symbol, decimals, totalSupply, token, error;

      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context15.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                address: address,
                formatUnits: formatUnits
              };

              if (config_.address) {
                _context15.next = 6;
                break;
              }

              throw new Error('address is required');

            case 6:
              contract = new ethers.Contract(config_.address, erc20ABI, provider);
              formatUnits_ = (_config_$formatUnits = config_.formatUnits) !== null && _config_$formatUnits !== void 0 ? _config_$formatUnits : 'ether';
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  error: undefined,
                  loading: true
                });
              });
              _context15.next = 11;
              return Promise.all([contract.symbol(), contract.decimals(), contract.totalSupply()]);

            case 11:
              _yield$Promise$all = _context15.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              symbol = _yield$Promise$all2[0];
              decimals = _yield$Promise$all2[1];
              totalSupply = _yield$Promise$all2[2];
              token = {
                address: config_.address,
                decimals: decimals,
                symbol: symbol,
                totalSupply: {
                  formatted: utils.formatUnits(totalSupply, formatUnits_),
                  value: totalSupply
                }
              };

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    token: token,
                    loading: false
                  });
                });
              }

              return _context15.abrupt("return", {
                data: token,
                error: undefined
              });

            case 21:
              _context15.prev = 21;
              _context15.t0 = _context15["catch"](2);
              error = _context15.t0;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context15.abrupt("return", {
                data: undefined,
                error: error
              });

            case 26:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[2, 21]]);
    }));

    return function (_x12) {
      return _ref32.apply(this, arguments);
    };
  }(), [address, cancelQuery, formatUnits, provider]);
  var watchToken = React.useCallback( /*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(token) {
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              if (connector !== null && connector !== void 0 && connector.watchAsset) {
                _context16.next = 2;
                break;
              }

              return _context16.abrupt("return", false);

            case 2:
              _context16.prev = 2;
              _context16.next = 5;
              return connector.watchAsset(token);

            case 5:
              return _context16.abrupt("return", true);

            case 8:
              _context16.prev = 8;
              _context16.t0 = _context16["catch"](2);
              return _context16.abrupt("return", _context16.t0);

            case 11:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, null, [[2, 8]]);
    }));

    return function (_x13) {
      return _ref33.apply(this, arguments);
    };
  }(), [connector]);
  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip || !address) return;
    getToken({
      address: address,
      formatUnits: formatUnits
    });
    return cancelQuery;
  }, [address, cancelQuery, formatUnits, skip]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [{
    data: state.token ? _objectSpread(_objectSpread({}, state.token), {}, {
      address: address
    }) : undefined,
    error: state.error,
    loading: state.loading
  }, watchToken, getToken];
};

var initialState$1 = {
  loading: false
};

var useTransaction = function useTransaction() {
  var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      request = _ref34.request;

  var _useContext12 = useContext(),
      connector = _useContext12.state.connector;

  var _React$useState33 = React.useState(initialState$1),
      _React$useState34 = _slicedToArray(_React$useState33, 2),
      state = _React$useState34[0],
      setState = _React$useState34[1];

  var cancelQuery = useCancel();
  var sendTransaction = React.useCallback( /*#__PURE__*/function () {
    var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(config) {
      var didCancel, config_, signer, transaction, error;
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context17.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                request: request
              };

              if (config_.request) {
                _context17.next = 6;
                break;
              }

              throw new Error('request is required');

            case 6:
              if (connector) {
                _context17.next = 8;
                break;
              }

              throw new ConnectorNotFoundError();

            case 8:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  loading: true
                });
              });
              _context17.next = 11;
              return connector.getSigner();

            case 11:
              signer = _context17.sent;
              _context17.next = 14;
              return signer.sendTransaction(config_.request);

            case 14:
              transaction = _context17.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    loading: false,
                    transaction: transaction
                  });
                });
              }

              return _context17.abrupt("return", {
                data: transaction,
                error: undefined
              });

            case 19:
              _context17.prev = 19;
              _context17.t0 = _context17["catch"](2);
              error = _context17.t0;
              if (_context17.t0.code === 4001) error = new UserRejectedRequestError();

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context17.abrupt("return", {
                data: undefined,
                error: error
              });

            case 25:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, null, [[2, 19]]);
    }));

    return function (_x14) {
      return _ref35.apply(this, arguments);
    };
  }(), [cancelQuery, connector, request]);
  return [{
    data: state.transaction,
    error: state.error,
    loading: state.loading
  }, sendTransaction];
};

var initialState = {
  loading: false
};

var useWaitForTransaction = function useWaitForTransaction() {
  var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      confirmations = _ref36.confirmations,
      hash = _ref36.hash,
      skip = _ref36.skip,
      timeout = _ref36.timeout,
      wait_ = _ref36.wait;

  var provider = useProvider();

  var _React$useState35 = React.useState(initialState),
      _React$useState36 = _slicedToArray(_React$useState35, 2),
      state = _React$useState36[0],
      setState = _React$useState36[1];

  var cancelQuery = useCancel();
  var wait = React.useCallback( /*#__PURE__*/function () {
    var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(config) {
      var didCancel, config_, promise, receipt, error;
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              didCancel = false;
              cancelQuery(function () {
                didCancel = true;
              });
              _context18.prev = 2;
              config_ = config !== null && config !== void 0 ? config : {
                confirmations: confirmations,
                hash: hash,
                timeout: timeout,
                wait: wait_
              };

              if (!(!config_.hash && !config_.wait)) {
                _context18.next = 6;
                break;
              }

              throw new Error('hash or wait is required');

            case 6:
              if (!config_.wait) {
                _context18.next = 10;
                break;
              }

              promise = config_.wait(config_.confirmations);
              _context18.next = 15;
              break;

            case 10:
              if (!config_.hash) {
                _context18.next = 14;
                break;
              }

              promise = provider.waitForTransaction(config_.hash, config_.confirmations, config_.timeout);
              _context18.next = 15;
              break;

            case 14:
              throw new Error('hash or wait is required');

            case 15:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  loading: true
                });
              });
              _context18.next = 18;
              return promise;

            case 18:
              receipt = _context18.sent;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    loading: false,
                    receipt: receipt
                  });
                });
              }

              return _context18.abrupt("return", {
                data: receipt,
                error: undefined
              });

            case 23:
              _context18.prev = 23;
              _context18.t0 = _context18["catch"](2);
              error = _context18.t0;

              if (!didCancel) {
                setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    error: error,
                    loading: false
                  });
                });
              }

              return _context18.abrupt("return", {
                data: undefined,
                error: error
              });

            case 28:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, null, [[2, 23]]);
    }));

    return function (_x15) {
      return _ref37.apply(this, arguments);
    };
  }(), [cancelQuery, confirmations, hash, provider, timeout, wait_]); // Fetch balance when deps or chain changes

  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (skip || !hash && !wait_) return;
    /* eslint-disable testing-library/await-async-utils */

    wait({
      confirmations: confirmations,
      hash: hash,
      timeout: timeout,
      wait: wait_
    });
    /* eslint-enable testing-library/await-async-utils */

    return cancelQuery;
  }, [cancelQuery, hash, skip, wait_]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [{
    data: state.receipt,
    error: state.error,
    loading: state.loading
  }, wait];
};

var Context = /*#__PURE__*/React.createContext(null);

var Provider = function Provider(_ref) {
  var _state$data2, _state$data2$chain, _state$data4, _state$data4$chain, _state$data6, _state$data6$chain;

  var _ref$autoConnect = _ref.autoConnect,
      autoConnect = _ref$autoConnect === void 0 ? false : _ref$autoConnect,
      children = _ref.children,
      _ref$connectors = _ref.connectors,
      connectors_ = _ref$connectors === void 0 ? [new InjectedConnector()] : _ref$connectors,
      _ref$connectorStorage = _ref.connectorStorageKey,
      connectorStorageKey = _ref$connectorStorage === void 0 ? 'wagmi.wallet' : _ref$connectorStorage,
      _ref$provider = _ref.provider,
      provider_ = _ref$provider === void 0 ? getDefaultProvider() : _ref$provider,
      webSocketProvider_ = _ref.webSocketProvider;

  var _useLocalStorage = useLocalStorage(connectorStorageKey),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      lastUsedConnector = _useLocalStorage2[0],
      setLastUsedConnector = _useLocalStorage2[1];

  var _React$useState37 = React.useState({
    cacheBuster: 1,
    connecting: autoConnect
  }),
      _React$useState38 = _slicedToArray(_React$useState37, 2),
      state = _React$useState38[0],
      setState = _React$useState38[1];

  var connectors = React.useMemo(function () {
    var _state$data, _state$data$chain;

    if (typeof connectors_ !== 'function') return connectors_;
    return connectors_({
      chainId: (_state$data = state.data) === null || _state$data === void 0 ? void 0 : (_state$data$chain = _state$data.chain) === null || _state$data$chain === void 0 ? void 0 : _state$data$chain.id
    });
  }, [connectors_, (_state$data2 = state.data) === null || _state$data2 === void 0 ? void 0 : (_state$data2$chain = _state$data2.chain) === null || _state$data2$chain === void 0 ? void 0 : _state$data2$chain.id]);
  var provider = React.useMemo(function () {
    var _state$data3, _state$data3$chain;

    if (typeof provider_ !== 'function') return provider_;
    return provider_({
      chainId: (_state$data3 = state.data) === null || _state$data3 === void 0 ? void 0 : (_state$data3$chain = _state$data3.chain) === null || _state$data3$chain === void 0 ? void 0 : _state$data3$chain.id,
      connector: state.connector
    });
  }, [provider_, (_state$data4 = state.data) === null || _state$data4 === void 0 ? void 0 : (_state$data4$chain = _state$data4.chain) === null || _state$data4$chain === void 0 ? void 0 : _state$data4$chain.id, state.connector]);
  var webSocketProvider = React.useMemo(function () {
    var _state$data5, _state$data5$chain;

    if (!webSocketProvider_) return undefined;
    if (typeof webSocketProvider_ !== 'function') return webSocketProvider_;
    return webSocketProvider_({
      chainId: (_state$data5 = state.data) === null || _state$data5 === void 0 ? void 0 : (_state$data5$chain = _state$data5.chain) === null || _state$data5$chain === void 0 ? void 0 : _state$data5$chain.id,
      connector: state.connector
    });
  }, [webSocketProvider_, (_state$data6 = state.data) === null || _state$data6 === void 0 ? void 0 : (_state$data6$chain = _state$data6.chain) === null || _state$data6$chain === void 0 ? void 0 : _state$data6$chain.id, state.connector]); // Attempt to connect on mount

  /* eslint-disable react-hooks/exhaustive-deps */

  React.useEffect(function () {
    if (!autoConnect) return;

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
      var sorted, _iterator, _step, _loop, _ret;

      return _regeneratorRuntime.wrap(function _callee19$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  connecting: true
                });
              });
              sorted = lastUsedConnector ? _toConsumableArray(connectors).sort(function (x) {
                return x.name === lastUsedConnector ? -1 : 1;
              }) : connectors;
              _iterator = _createForOfIteratorHelper(sorted);
              _context20.prev = 3;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var connector, isAuthorized, data;
                return _regeneratorRuntime.wrap(function _loop$(_context19) {
                  while (1) {
                    switch (_context19.prev = _context19.next) {
                      case 0:
                        connector = _step.value;

                        if (!(!connector.ready || !connector.isAuthorized)) {
                          _context19.next = 3;
                          break;
                        }

                        return _context19.abrupt("return", "continue");

                      case 3:
                        _context19.next = 5;
                        return connector.isAuthorized();

                      case 5:
                        isAuthorized = _context19.sent;

                        if (isAuthorized) {
                          _context19.next = 8;
                          break;
                        }

                        return _context19.abrupt("return", "continue");

                      case 8:
                        _context19.next = 10;
                        return connector.connect();

                      case 10:
                        data = _context19.sent;
                        setState(function (x) {
                          return _objectSpread(_objectSpread({}, x), {}, {
                            connector: connector,
                            data: data
                          });
                        });
                        return _context19.abrupt("return", "break");

                      case 13:
                      case "end":
                        return _context19.stop();
                    }
                  }
                }, _loop);
              });

              _iterator.s();

            case 6:
              if ((_step = _iterator.n()).done) {
                _context20.next = 15;
                break;
              }

              return _context20.delegateYield(_loop(), "t0", 8);

            case 8:
              _ret = _context20.t0;

              if (!(_ret === "continue")) {
                _context20.next = 11;
                break;
              }

              return _context20.abrupt("continue", 13);

            case 11:
              if (!(_ret === "break")) {
                _context20.next = 13;
                break;
              }

              return _context20.abrupt("break", 15);

            case 13:
              _context20.next = 6;
              break;

            case 15:
              _context20.next = 20;
              break;

            case 17:
              _context20.prev = 17;
              _context20.t1 = _context20["catch"](3);

              _iterator.e(_context20.t1);

            case 20:
              _context20.prev = 20;

              _iterator.f();

              return _context20.finish(20);

            case 23:
              setState(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  connecting: false
                });
              });

            case 24:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee19, null, [[3, 17, 20, 23]]);
    }))();
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */
  // Make sure connectors close

  React.useEffect(function () {
    return function () {
      if (!state.connector) return;
      state.connector.disconnect();
    };
  }, [state.connector]); // Watch connector for events

  React.useEffect(function () {
    if (!state.connector) return;

    var onChange = function onChange(data) {
      return setState(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          cacheBuster: x.cacheBuster + 1,
          data: _objectSpread(_objectSpread({}, x.data), data)
        });
      });
    };

    var onDisconnect = function onDisconnect() {
      return setState({
        cacheBuster: 1
      });
    };

    var onError = function onError(error) {
      return setState(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          error: error
        });
      });
    };

    state.connector.on('change', onChange);
    state.connector.on('disconnect', onDisconnect);
    state.connector.on('error', onError);
    return function () {
      if (!state.connector) return;
      state.connector.off('change', onChange);
      state.connector.off('disconnect', onDisconnect);
      state.connector.off('error', onError);
    };
  }, [state.connector]);
  var value = {
    state: {
      cacheBuster: state.cacheBuster,
      connecting: state.connecting,
      connectors: connectors,
      connector: state.connector,
      data: state.data,
      provider: provider,
      webSocketProvider: webSocketProvider
    },
    setState: setState,
    setLastUsedConnector: setLastUsedConnector
  };
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: value
  }, children);
};

var useContext = function useContext() {
  var context = React.useContext(Context);
  if (!context) throw Error('Must be used within Provider');
  return context;
};

export { Context, Provider, Provider as WagmiProvider, useAccount, useBalance, useBlockNumber, useConnect, useContext, useContract, useContractEvent, useContractRead, useContractWrite, useEnsAvatar, useEnsLookup, useEnsResolveName, useEnsResolver, useFeeData, useNetwork, useProvider, useSignMessage, useSignTypedData, useSigner, useToken, useTransaction, useWaitForTransaction, useWebSocketProvider };